import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { HttpParams } from '@angular/common/http';
import { NewAddedCategoriesService } from '../../../../Services/new-added-categories.service';

@Component({
  selector: 'app-new-added-categories',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './new-added-categories.component.html',
})
export class NewAddedCategoriesComponent implements OnInit {

  // 🔹 Tabs
  activeTab: 'all' | 'ready' | 'assembly' = 'all';
  showReady = true;
  showAssembly = true;

  // 🔹 Data
  readyProducts: any[] = [];
  assemblyLine: any[] = [];

  // 🔹 Stats cards
  stats: any[] = [];

  constructor(
    private newAddedCategoriesService: NewAddedCategoriesService
  ) {}

  ngOnInit(): void {
    this.fetchNewCategories();
  }

  // ----------------------------
  // FETCH FULL REPORT DATA
  // ----------------------------
  fetchNewCategories() {
    const params = new HttpParams(); // add firm_id later if needed

    this.newAddedCategoriesService.getNewAddedCategories(params).subscribe({
      next: (res: any) => {
        const data = res?.data || {};

        this.readyProducts = data.ready_products || [];
        this.assemblyLine = data.assembly_products || [];

        this.buildStats();

        console.log('Ready Products:', this.readyProducts);
        console.log('Assembly Products:', this.assemblyLine);
      },
      error: (err) => {
        console.error('New categories fetch failed', err);
        this.readyProducts = [];
        this.assemblyLine = [];
      }
    });
  }

  // ----------------------------
  // STATS CARDS (TOP SUMMARY)
  // ----------------------------
  buildStats() {
    this.stats = [
      {
        label: 'Ready Products',
        value: this.readyProducts.length,
        icon: '💎',
        color: 'bg-purple-100 text-purple-700'
      },
      {
        label: 'Assembly Products',
        value: this.assemblyLine.length,
        icon: '⚒️',
        color: 'bg-blue-100 text-blue-700'
      }
    ];
  }

  // ----------------------------
  // TAB SWITCH
  // ----------------------------
  setTab(tab: 'all' | 'ready' | 'assembly') {
    this.activeTab = tab;

    if (tab === 'all') {
      this.showReady = true;
      this.showAssembly = true;
    } else if (tab === 'ready') {
      this.showReady = true;
      this.showAssembly = false;
    } else {
      this.showReady = false;
      this.showAssembly = true;
    }
  }
}
